import React from 'react';
import { Header, Icon, Modal, Table } from 'semantic-ui-react';
import { strings } from '../..';
import { datetimeFormatter } from '../../core';
import { TipoIntervento } from '../../core-assistenza';
import { Chiamata, StatoChiamata } from '../models';
import { getStatoValues } from '../utility';
import parse from 'html-react-parser';

export const numeroDocumentoFormatterComputer = (value: any): string => {
    return value === 0 ? '' : String(value);
}

export const numeroDocumentoFormatterMobile = (value: any): JSX.Element => {
    return value === 0 ? <></> : <>{'prot. '} <b>{String(value)}</b></>;
}

export const statoChiamataFormatter = (value: any, item: Chiamata): JSX.Element => {
    const stato = getStatoValues(value as StatoChiamata);

    const appuntamento = item.appuntamento === null ?
        (<></>) :
        (<> ({datetimeFormatter(item.appuntamento)})</>)

    return (
        <>
            <Icon name={stato.name} color={stato.color} />
            {stato.text}
            {appuntamento}
        </>
    );
}

export const tipoInterventoFormatter = (value: any): string => {
    const tipoIntervento = value as TipoIntervento;
    switch (tipoIntervento) {
        case TipoIntervento.Hardware: return "Hardware";
        case TipoIntervento.Software: return "Software";
        default: return "";
    }
}

export const ubicazioneFormatter = (value: any): string | JSX.Element => {
    const ubicazione = value as string;
    if (ubicazione) {
        return parse(ubicazione) as JSX.Element;
    }
    return "";
}

export const dettagliFormatter = (_: any, item: Chiamata) => {
    const descrizioneAggiuntivaFormattata = (
        item.descrizioneAggiuntiva.split(/\r?\n/).map((s, index) => <span key={index}>{s} <br /></span>)
    )
    return (
        <Modal trigger={<Icon name='tasks' bordered />} closeIcon>
            <Header icon='warning sign' content={strings.chiamate.elenco.dettagliRichiesta} />
            <Modal.Content>
                <Table attached definition fixed unstackable>
                    <Table.Body>
                        <Table.Row key={1}>
                            <Table.Cell width='4'>{strings.chiamate.elenco.dataTable.utente}</Table.Cell>
                            <Table.Cell>{item.userName}</Table.Cell>
                        </Table.Row>
                        <Table.Row key={2}>
                            <Table.Cell>{strings.chiamate.elenco.dataTable.descrizione}</Table.Cell>
                            <Table.Cell>{descrizioneAggiuntivaFormattata}</Table.Cell>
                        </Table.Row>
                        <Table.Row key={3}>
                            <Table.Cell>{strings.chiamate.riepilogo.referente}</Table.Cell>
                            <Table.Cell>{item.referente}</Table.Cell>
                        </Table.Row>
                        {item.stato === StatoChiamata.Rifiutato &&
                            <Table.Row key={4}>
                                <Table.Cell>{strings.chiamate.elenco.dataTable.motivoRifiuto}</Table.Cell>
                                <Table.Cell>{item.motivoRifiuto}</Table.Cell>
                            </Table.Row>}
                    </Table.Body>
                </Table>
            </Modal.Content>
        </Modal>
    );
}